<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>请假申请</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="加盟商">
                    <el-select placeholder="请选择" clearable filterable v-model="listQuery.fraId" width="100px">
                        <el-option v-for="item in franchiseeList" :key="item.id" :label="item.fraName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                            :value="item.id + ''"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="驿站">
                    <el-select v-model="listQuery.postStationId" clearable placeholder="请选择驿站" filterable>
                        <template v-for="(item, index) in postStationList">
                            <el-option :key="index" v-if="item.cityId == listQuery.cityId" :label="item.postStationName"
                                :value="item.id + ''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="服务站">
                    <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站" filterable>
                        <template v-for="(item, index) in allStationList">
                            <el-option :key="index" v-if="item.cityId == listQuery.cityId"
                                :label="item.stationName" :value="item.id + ''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item>


                <el-form-item label="请假申请人">
                    <el-input v-model="listQuery.workerName" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>

                <el-form-item label="请假大类">
                    <el-select v-model="listQuery.leavePid" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in leaveTypeAll" :key="index" :label="item.typeName"
                            :value="item.id"> </el-option>

                    </el-select>
                </el-form-item>

                <el-form-item label="请假类型">
                    <el-cascader v-model="listQuery.leaveTypeId" :options="leaveTypeAll" :props="{
                        expandTrigger: 'hover', value: 'id', label: 'typeName',
                        children: 'subList', emitPath: false
                    }" clearable :show-all-levels="false" size="mini"></el-cascader>
                </el-form-item>


                <el-form-item label="状态">
                    <el-select v-model="listQuery.state" clearable placeholder="请选择状态" filterable>
                        <el-option v-for="(item, index) in stateKey" :key="index" :label="item" :value="index + ''">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button v-per="'faqiqingjia'" type="primary" class="el-icon-plus" plan @click="clickLeavePost">
                        发起请假</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" tooltip-effect="light" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>

                <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
                <el-table-column prop="workerName" label="服务者"></el-table-column>
                <!-- <el-table-column prop="leaveTypeName" label="请假大类"></el-table-column> -->
                <el-table-column prop="leaveTypeName" label="请假类型"></el-table-column>
                <el-table-column prop="leaveStartTime" :formatter="dateFormatA" label="请假开始时间"></el-table-column>
                <el-table-column prop="leaveEndTime" :formatter="dateFormatA" label="请假结束时间"></el-table-column>
                <el-table-column prop="leaveReason" show-overflow-tooltip label="请假事由说明"></el-table-column>
                <el-table-column prop="leaveImages" label="图片" width="100px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.leaveImages == ''">无</span>
                        <el-image v-else slot="reference" :preview-src-list="scope.row.leaveImages.split(',')"
                            v-for="item in scope.row.leaveImages.split(',')" :key="item.index" :src="item"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state == 0">{{ stateKey[scope.row.state] }}</el-tag>
                        <el-tag type="success" v-if="scope.row.state == 1">{{ stateKey[scope.row.state] }}</el-tag>
                        <el-tag type="danger" v-if="scope.row.state == 2">{{ stateKey[scope.row.state] }}</el-tag>
                        <el-tag type="warning" v-if="scope.row.state == 3">{{ stateKey[scope.row.state] }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="盒马处理状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.operHm == 0">未处理</el-tag>
                        <el-tag type="success" v-if="scope.row.operHm == 1">已处理</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="examineName" label="审核人"></el-table-column>
                <el-table-column prop="examineTime" :formatter="dateFormatA" label="审核时间"></el-table-column>
                <el-table-column prop="examineComment" show-overflow-tooltip label="审核说明"></el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

                <el-table-column label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                        <el-button v-per="'quxiaofaqiqingjia'" type="warning" plain size="mini" v-show="scope.row.state == 0"
                            @click="handleDel(scope.$index, scope.row)">取消请假</el-button>
                        <el-button v-per="'shenpiqingjia'" type="primary" plain size="mini" v-show="scope.row.state == 0"
                            @click="clickapprovalLeave(scope.$index, scope.row)">审批</el-button>
                        <el-button v-per="'chuliqingjia'" type="primary" plain size="mini" v-show="scope.row.state == 1 && scope.row.operHm == 0"
                            @click="showchuli(scope.row)">处理请假
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="发起请假" :visible.sync="showAdd" width="700px" :close-on-click-modal="false" center>
            <el-row style="color:red;"><center>由于后台请假不要求审批，默认通过，请留意服务者请假时间段的工单</center></el-row>
            <el-form inline label-width="100px">
                <el-row>
                    <el-form-item label="城市">
                        <el-select v-model="addFrom.cityId" clearable placeholder="请选择城市" filterable>
                            <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                                :value="item.id + ''"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="驿站">
                        <el-select v-model="addFrom.postStationId" @change="getAllWorker" clearable placeholder="请选择驿站"
                            filterable>
                            <template v-for="(item, index) in postStationList">
                                <el-option :key="index" v-if="item.cityId == addFrom.cityId" :label="item.postStationName"
                                    :value="item.id + ''"> </el-option>
                            </template>
                        </el-select>
                    </el-form-item> -->
                </el-row>

                <el-row>
                    <el-form-item label="服务站">
                        <el-select v-model="addFrom.stationId" @change="getAllWorker" clearable placeholder="请选择服务站"
                            filterable>
                            <template v-for="(item, index) in allStationList">
                                <el-option :key="index" v-if="item.cityId == addFrom.cityId"
                                    :label="item.stationName" :value="item.id + ''"> </el-option>
                            </template>
                        </el-select>
                    </el-form-item>

                </el-row>
                <el-row>
                   <el-form-item label="服务者">
                        <el-select v-model="addFrom.workerNo" clearable placeholder="请选择服务者" filterable>
                            <template v-for="(item, index) in allWorkerData">
                                <el-option :key="index" :label="item.workerName" :value="item.workerNo"> </el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="请假类型">
                        <el-cascader v-model="addFrom.leaveTypeId" :options="leaveTypeAll" :props="{
                            expandTrigger: 'hover', value: 'id', label: 'typeName',
                            children: 'subList', emitPath: false
                        }" clearable :show-all-levels="false">
                        </el-cascader>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="请假时间范围">
                        <el-date-picker v-model="addFrom.timePart" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                            range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                            :picker-options="{}"></el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="请假原因">
                        <el-input type="textarea" clearable v-model="addFrom.leaveReason" style="width:400px;">
                        </el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="相关凭证图片:"></el-form-item>
                </el-row>
                <el-upload :action="addFile" :on-change="handleOnChange" :file-list="addLabelImgList" :limit="3"
                    :on-exceed="uploadOverrun" :auto-upload="false" :on-remove="handleRemove"
                    accept=".jpg, .jpeg, .png, .gif" list-type="picture-card">
                    <i class="el-icon-plus" />
                </el-upload>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showAdd = false">关闭</el-button>
                <el-button type="primary" @click="commitLeave">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="审批请假" :visible.sync="showSP" width="800px" :close-on-click-modal="false" center>
            <el-table :data="bookDataList" tooltip-effect="light" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="id" label="工单编号"></el-table-column>
                <el-table-column prop="bookTime" label="预约时间" width="155"></el-table-column>
                <el-table-column prop="servantName" label="服务者姓名"></el-table-column>
                <el-table-column prop="servantMobile" label="服务者手机"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        {{ bookorderState[scope.row.status] }}
                    </template>
                </el-table-column>
            </el-table>
            <br />

            <el-form>
                <el-form-item label="审批结果">
                    <el-select v-model="approvalForm.state" clearable placeholder="请选择" filterable>
                        <el-option label="通过" value="1"> </el-option>
                        <el-option label="未通过" value="2"> </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="审批原因">
                    <el-input type="textarea" clearable v-model="approvalForm.examineComment"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showSP = false">取消</el-button>
                <el-button type="primary" @click="configApprovalLeave">确认</el-button>
            </span>
        </el-dialog>


        <el-dialog title="处理请假" :visible.sync="showcl" width="800px" :close-on-click-modal="false" center>
            <el-table :data="bookDataList" tooltip-effect="light" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="orderId" label="服务订单编号"></el-table-column>
                <el-table-column prop="bookTime" label="预约时间" width="155"></el-table-column>
                <el-table-column prop="servantName" label="服务者姓名"></el-table-column>
                <el-table-column prop="servantMobile" label="服务者手机"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        {{ bookorderState[scope.row.status] }}
                    </template>
                </el-table-column>
            </el-table>
            <br />
            <span slot="footer" class="dialog-footer">
                <el-button @click="showcl = false">取消</el-button>
                <el-button type="primary" @click="handleHMLeave">确认处理</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            bookorderState: { 0: '未预约', 1: '已预约', 2: '服务中', 3: '服务已提供', 4: '服务已完成', 5: '取消', 6: '退款' },
            addFile: crmApi.addFile + globalData.userInfo.userAccount,
            stateKey: { 0: "未审核", 1: "通过", 2: "未通过", 3: "取消请假" },
            leaveTypeAll: [],
            listData: [],
            bookDataList: [],

            cityList: [],
            postStationList: [],
            allStationList: [],
            allWorkerData: [],
            franchiseeList:[],

            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                workerName: null,
                state: null,
                leaveTypeId: null,
                cityId: null,
                postStationId: null,
                stationId: null,
                leavePid: null,
                fraId:293
            },
            addLabelImgList: [],
            addFrom: {
                cityId: null,
                postStationId: null,
                stationId: null,
                timePart: null,

                leaveTypeId: null,
                workerNo: null,
                leaveStartTime: null,
                leaveEndTime: null,
                leaveReason: null,
                leaveImages: null,
            },
            approvalForm: {
                id: null,
                state: null,
                examineComment: null,
                examineId: null,
                examineName: null,
            },
            showAdd: false,
            showSP: false,
            showcl: false,
            tempRow: {},
        };
    },

    created() {
        this.getAllCity();
        this.getAllPostStation();
        this.getAllStationList();

        this.getLeaveDictAll();
        this.querySearch();
        this.getAllJms();
    },
    methods: {
        getAllJms() {
            crmApi.$ajaxgetAllJms().then(res => {
                this.franchiseeList = res.data.data;
            })
        },
        showchuli(row) {
            this.showcl = true;
            this.tempRow = row;
            this.getbook(row);
        },
        handleHMLeave() {
            this.$confirm("是否确认处理（盒马系统请假）", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi
                        .$ajaxLeaveHandleHMLeave({
                            id: this.tempRow.id,
                            operId: globalData.userInfo.id
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.showcl = false;
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        configApprovalLeave() {
            if (
                this.approvalForm.state == null ||
                this.approvalForm.state == ""
            ) {
                this.$message.error("请选择审批结果");
                return;
            }
            if (
                this.approvalForm.state == 2 &&
                (this.approvalForm.examineComment == null ||
                    this.approvalForm.examineComment == "")
            ) {
                this.$message.error("请输入未通过原因");
                return;
            }
            crmApi.$ajaxworkerApprovalLeave(this.approvalForm).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showSP = false;
                    this.querySearch();
                }
            });
        },
        clickapprovalLeave(index, row) {
            //审批请假
            this.showSP = true;
            this.approvalForm = {
                id: row.id,
                state: null,
                examineComment: null,
                examineId: globalData.userInfo.id,
                examineName: globalData.userInfo.userName,
            };
            this.getbook(row);
        },
        getbook(row) {
            //bookDataList
            crmApi.$ajaxGetDispatchOrder({
                id: row.id,
            }).then((res) => {
                if (res.data.errno == 0) {
                    this.bookDataList = res.data.data;
                }
            });
        },
        handleDel(index, row) {
            this.$confirm("是否确认取消?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi
                        .$ajaxworkerCancelLeave({
                            id: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("取消成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        handleOnChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (file.raw) {
                console.log("上传文件大小" + file.raw.size);
                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file.raw);
                wmsApi.$ajaxAddFile(param).then((res) => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        console.log(res);
                        file.url = res.data.data.fileUrl;
                        this.addLabelImgList = fileList;
                    }
                });
            }
        },
        uploadOverrun: function () {
            this.$message({
                type: "error",
                message: "上传文件个数超出限制!最多上传3张图片!",
            });
        },
        handleRemove: function (file, fileList) {
            console.log(file, fileList);
            this.addLabelImgList = fileList;
        },
        clickLeavePost() {
            this.showAdd = true;
            this.addLabelImgList = [];
            this.addFrom = {
                cityId: null,
                postStationId: null,
                stationId: null,
                timePart: null,

                leaveTypeId: null,
                workerNo: null,
                leaveStartTime: null,
                leaveEndTime: null,
                leaveReason: null,
                leaveImages: null,
            };
        },
        commitLeave() {
            console.log(this.addFrom);

            if (this.addFrom.workerNo == null || this.addFrom.workerNo == "") {
                this.$message.error("请选择服务者");
                return;
            }
            if (
                this.addFrom.leaveTypeId == null ||
                this.addFrom.leaveTypeId == ""
            ) {
                this.$message.error("请选择请假类型");
                return;
            }
            if (
                this.addFrom.timePart == null ||
                this.addFrom.timePart.length == 0
            ) {
                this.$message.error("请选择请假时间范围");
                return;
            }
            if (
                this.addFrom.leaveReason == null ||
                this.addFrom.leaveReason == ""
            ) {
                this.$message.error("请输入请假原因");
                return;
            }

            let imgs = this.addLabelImgList.map((item) => {
                return item.url;
            });

            let req = {
                leaveTypeId: this.addFrom.leaveTypeId,
                workerNo: this.addFrom.workerNo,
                leaveStartTime: this.addFrom.timePart[0],
                leaveEndTime: this.addFrom.timePart[1],
                leaveReason: this.addFrom.leaveReason,
                leaveImages: imgs.join(","),
            };

            crmApi.$ajaxworkerSubmitLeave(req).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("发起成功");
                    this.showAdd = false;
                    this.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            this.listQuery.userId = globalData.userInfo.id;
            crmApi.$ajaxworkerGetPageList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getAllWorker() {
            if (this.addFrom.cityId == null || this.addFrom.cityId == "") {
                return; //至少选择城市
            }
            let req = {
                cityId: this.addFrom.cityId,
                postStationId: this.addFrom.postStationId,
                stationId: this.addFrom.stationId,
            };
            crmApi.$ajaxWorkerSupplierGetWorker(req).then((res) => {
                if (res.data.errno == 0) {
                    this.allWorkerData = res.data.data;
                }
            });
        },
        getAllPostStation() {
            //驿站
            crmApi.$axiosPostStationgetAllList({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.postStationList = res.data.data;
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getAllStationList() {
            //服务站
            wmsApi.$axiosGetAllStationList({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.allStationList = res.data.data;
                }
            });
        },
        getcity(id) {
            let nm = null;
            this.cityList.forEach((e) => {
                if (e.id == id) {
                    nm = e.cityName;
                }
            });
            return nm;
        },
        getLeaveDictAll() {
            crmApi.$ajaxworkerLeaveGetAllType().then((res) => {
                if (res.data.errno == 0) {
                    this.leaveTypeAll = res.data.data;
                }
            });
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
